import React from 'react';
import {Link} from 'react-router-dom';
import {siteConfig} from '../../settings';
import KarieLogo from '../../components/kariePortalLogo/karieLogo';
import Icon from '../../image/svg/icons';
import KarieLogoHorizontal from "../kariePortalLogo/KarieLogoHorizontal";

export default ({collapsed}) => {
  return (
    <div className="isoLogoWrapper">
      {collapsed ? (
        <div className="k_icon">
          <Link to="/dashboard">
            <Icon icon={'karie_k_icon'} style={{fill: '#4fbe96', width: 50, height: 50}} />
          </Link>
        </div>
      ) : (
          <KarieLogoHorizontal directTo="/dashboard" />
        )}
    </div>
  );
};
